<div class="card">
    <div class="card-header">
        Reset Device
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Employee Type:</label>
            </div>
            <div class="col px-1">
                <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="EmployeeType" value="Front"
                        [(ngModel)]="EmployeeType" (click)="onSelectionChange('EmployeeType',$event)"> Front
                </label>
                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="EmployeeType" value="Back"
                        [(ngModel)]="EmployeeType" (click)="onSelectionChange('EmployeeType',$event)"> Back
                </label>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Employee Code:<span class="text-danger">*</span></label>
            </div>
            <div class="col-md-4 px-1">
                <input name="Employeecode" [(ngModel)]="EmployeeCode" type="text" class="form-control"
                    (keypress)="onKeyPress($event)" placeholder="Enter Code"  />
            </div>
            <div class="col-md-2 px-1">
                <!-- <button class="btn btn-sm btn-primary" name="Search" (click)="Search()"><i class="bi bi-search"></i>
                    Search
                </button> -->
                <button class="btn btn-sm btn-primary" name="submit" (click)="Search()">
                    <i class="bi bi-search" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}
                </button>
            </div>
        </div>
        <hr>
        <div>
            <div class="card border-radius-0 mt-1 p-0">
                <div class="card-header">
                    Data
                </div>
                <div class="card-body p-1" style="overflow: auto;">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Branch Name</th>
                                <th scope="col">Full Name</th>
                                <th scope="col">Employee Code</th>
                                <th scope="col">IMEI No.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let site of IMEINoLoad; let i = index">
                                <th scope="row">{{ i + 1 }}</th>
                                <td>{{ site['Branch'] }}</td>
                                <td>{{ site['FullName'] }}</td>
                                <td>{{ site['EmpCode'] }}</td>
                                <td>{{ site['IMEINumber'] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <!-- <button class="btn btn-sm btn-primary" name="checkout" (click)="Reset()"><i
                        class="bi bi-arrow-clockwise"></i> Reset
                </button> -->
                <button *ngIf="this.common.PageRight.IsEdit" class="btn btn-sm btn-primary" name="submit"
                    (click)="Reset()">
                    <i class="bi bi-arrow-clockwise" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Reset':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>